import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useMatch } from 'react-router-dom';
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Home from './Pages/Home';
import LoginSignup from "./Pages/LoginSignup";
import VerifyEmail from './Components/VerifyEmail/VerifyEmail';
import ResendVerification from './Components/VerifyEmail/ResendVerification';
import EmailVerified from './Components/VerifyEmail/EmailVerified';
import VerificationError from './Components/VerifyEmail/VerificationError';
import UserDashboard from "./Pages/Dashboard";
import ProductTemplate from './Pages/ProductTemplate';
import SyncX from './Pages/SyncX';

function App() {
  const [user] = useState(null);
  const [pageReady, setPageReady] = useState(false); // 🆕 page readiness flag

  return (
    <Router>
      <AppContent user={user} setPageReady={setPageReady} pageReady={pageReady} />
    </Router>
  );
}

function AppContent({ user, setPageReady, pageReady }) {
  const isProductPage = useMatch('/product/:productId');
  const isSyncxPage = useMatch('/Syncx/*');
  const hideNavbarFooter = isProductPage || isSyncxPage;

  return (
    <div className="App">
      {!hideNavbarFooter && <Navbar user={user} />}
      <Routes>
        <Route path="/" element={<Home setPageReady={setPageReady} />} />
        <Route path="/account" element={<LoginSignup isInline={true} />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/resend-verification" element={<ResendVerification />} />
        <Route path="/email-verified" element={<EmailVerified />} />
        <Route path="/verification-error" element={<VerificationError />} />
        <Route path="/Dashboard" element={<UserDashboard />} />
        <Route path="/product/:productId" element={<ProductTemplate />} />
        <Route path="/syncx/*" element={<SyncX />} />
      </Routes>
      {/* Only delay footer rendering on home */}
      {!hideNavbarFooter && <Footer user={user} />}
    </div>
  );
}

export default App;
